import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.5398 4.31514C10.7138 4.01702 10.6132 3.6343 10.315 3.46031C10.0169 3.28632 9.6342 3.38694 9.46021 3.68506L6.3239 9.05882L4.39046 7.51206C4.12092 7.29643 3.72761 7.34013 3.51198 7.60967C3.29635 7.8792 3.34005 8.27251 3.60959 8.48814L5.65683 10.1259C5.78266 10.2286 5.92958 10.3022 6.08714 10.3416C6.24507 10.3811 6.40975 10.3852 6.56941 10.3536C6.72668 10.3235 6.87574 10.2601 7.00659 10.1678C7.13847 10.0747 7.24901 9.95387 7.33024 9.81439L10.5398 4.31514Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }